import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransformationSection } from './components/TransformationSection';
import { BonusStack } from './components/BonusStack';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingOptions } from './components/PricingOptions';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { OpportunityCost } from './components/OpportunityCost';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesNotifications } from './components/SalesNotifications';
import { WhatsAppButton } from './components/WhatsAppButton';
import { LinkPreloader } from './components/LinkPreloader';
import { SystemPromise } from './components/SystemPromise';
import { ContentPreview } from './components/ContentPreview';
import { ExpertoValueAdds } from './components/ExpertoValueAdds';
export function App() {
  return <div className="min-h-screen bg-navy-950 font-sans text-white overflow-x-hidden selection:bg-gold selection:text-navy-950" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <LinkPreloader data-id="element-2" />
      <Hero data-id="element-3" />
      <SystemPromise data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <BonusStack data-id="element-8" />
      <UrgencyBlock data-id="element-9" />
      <ContentPreview data-id="element-10" />
      <PricingOptions data-id="element-11" />
      <ExpertoValueAdds data-id="element-12" />
      <Testimonials data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <OpportunityCost data-id="element-16" />
      <FinalCTA data-id="element-17" />
      <Footer data-id="element-18" />
      <SalesNotifications data-id="element-19" />
      <WhatsAppButton data-id="element-20" />
    </div>;
}